<!--
 * @Author: Cathy
 * @Date: 2020-02-24 09:45:44
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:43:48
 * @Description: 头部菜单
 -->
<template>
 <div class="topMenu">
    <div class="top">
      <div class="popupMenu">
        <div class="popupItem" v-if="pageType !== 'recommend'" @click="pageType !== 'product' ? jumpTo('/productIndex') : onShowPopup()">
          <label :class="pageType === 'product'? 'selected' : ''">产品介绍</label>
        </div>
        <!-- <div class="popupItem" @click="pageType !== 'recommend' ? jumpTo('/download') : onShowPopup()">
          <label :class="pageType === 'recommend'? 'selected' : ''">联吧介绍</label>
        </div> -->
        <div class="popupItem" v-if="pageType !== 'recommend'" @click="pageType !== 'motor' ? jumpTo('/productDirection') : onShowPopup()">
          <label :class="pageType === 'motor'? 'selected' : ''">电机说明</label>
        </div>
      </div>
    </div>
    <div v-if="isShowMenu" class="menu">
      <div class="menuItem" @click="jumpTo('/download')">
        <img src="../assets/images/icon_lianbaxz_moren.png" :class="type === 'download' ?'imgSelected' : ''" />
        <!-- <p :class="type === 'download' ? 'textSelected' : ''">联吧下载</p> -->
      </div>
      <!-- <div class="menuItem" @click="jumpTo('/useVideo')">
        <img src="../assets/images/icon_shipin_weixuanzhong.png" :class="type === 'video' ?'imgSelected' : ''" /> -->
        <!-- <p :class="type === 'video' ? 'textSelected' : ''">使用视频</p> -->
      <!-- </div>
      <div class="menuItem" @click="jumpTo('/useDirection')">
        <img src="../assets/images/icon_shiyongsm_moren.png" :class="type === 'useDirection' ?'imgSelected' : ''" /> -->
        <!-- <p :class="type === 'useDirection' ? 'textSelected' : ''">使用说明</p> -->
      <!-- </div> -->
    </div>
 </div>
</template>

<script>
export default {
  name: 'topMenu',
  components: {},
  props: {
    type: {
      type: String,
      default: 'download'
    },
    isShowMenu: {
      type: Boolean,
      default: true
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    onShowPopup () {
      this.show = !this.show
    },
    jumpTo (url) {
      this.$router.push({
        path: url
      })
    }
  }
}
</script>

<style scoped>
.top img {
  width: 0.46rem;
  height: 0.46rem;
}
.topMenu >>> .van-overlay {
  background-color: rgba(0,0,0,0.4);
}
.topMenu >>> .van-popup {
  width: 2.88rem;
  top: 20%;
  left: 78%;
  border-radius: 0.1rem;
}
.menu {
  display: flex;
  margin-top: 0.76rem;
  justify-content: space-around;
  /* align-items: center; */
}
.menu .menuItem {
  text-align: center;
}
.menu .menuItem img {
  width:1.2rem;
  height:1.2rem;
  border-radius: 0.2rem;
  opacity: 0.6;
}
.menu .menuItem p {
  margin-top: 0.2rem;
  font-size: 0.26rem;
  color: #919191;
}
.imgSelected {
  width:1.2rem !important;
  height:1.2rem !important;
  box-shadow:0px 0px 10px 0px rgba(104,104,104,0.84);
  border-radius: 0.2rem;
  opacity: 1 !important;
}
.textSelected {
  margin-top: 0.2rem !important;
  font-size: 0.26rem !important;
  color: #121212 !important;
}
.popupMenu{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background: #1F1402;
}
.popupItem {
  display: flex;
  padding: 0.32rem 0;
  align-items: center;
}
.popupItem img {
  width: 0.43rem;
  height: 0.45rem;
}
.popupItem label {
  margin-left: 0.2rem;
  font-size: 0.32rem;
  color: rgba(145,145,145,1);
}
.selected {
  color: #ffffff !important;
}
</style>
